import { Component, Host, h, Listen, Method, Prop, State, Watch } from '@stencil/core'
import { SearchResultItem } from '../../../domain/models/search'
import { ProfessionalService } from '../../../domain/services/professional.service'
import { ProfessionalLeadService } from '../../../domain/services/professional_lead.service'

@Component({
  tag: 'cr-buckets-bar',
  styleUrl: 'cr-buckets-bar.css',
  shadow: true,
})
export class CrBucketsBar {

  /**
   * An application wide event bus
   */
  @Prop() applicationBus: any

  @State() openBuckets: boolean = false

  @State() discoveries: Array<SearchResultItem> = []
  @State() professionals: Array<SearchResultItem> = []
  @State() leads: Array<SearchResultItem> = []

  @Watch('discoveries')
  updateBuckets() {
    this.professionals = this.discoveries.filter(this.onlyProfessionals)
    this.leads = this.discoveries.filter(this.onlyLeads)
  }

  @Method()
  async addDiscovery(discovery: SearchResultItem) {
    const found = this.discoveries.findIndex(d => d.id === discovery.id)
    if (found === -1) {
      console.log('ole')
      const discoveryDetails = await this.getDiscoveryDetails(discovery)
      console.log(discoveryDetails)
      discovery.details = discoveryDetails
      this.discoveries = [...this.discoveries, discovery]
    }
    this.save()
  }

  @Listen('removedDiscovery')
  handleDiscoveryRemoval(e) {
    const found = this.discoveries.findIndex(discovery => discovery.id === e.detail.id)
    if (found >= 0) {
      this.discoveries.splice(found, 1)
      this.discoveries = [...this.discoveries]
    }
    this.save()
  }

  connectedCallback() {
    this.load()
    if (this.applicationBus) {
      this.applicationBus.on('addDiscovery', this.addDiscovery)
    }
  }

  disconnectedCallback() {
    this.save()
    if (this.applicationBus) {
      this.applicationBus.off('addDiscovery', this.addDiscovery)
    }
  }

  render() {
    return (
      <Host>
        {
          this.discoveries.length > 0 ?
          <div
            class="launcher solo"
            onClick={this.handleLauncherClicked}
          >
            <cr-icon-bucket size="large"/>
            <div class="discovery-count">{this.professionals.length + this.leads.length}</div>
          </div> : <div></div>
        }
        <bx-side-nav class={this.openBuckets ? "sidebar" : "sidebar closed"}>
          <bx-side-nav-items>
            <div class="side-nav-header">
              <div
                class="launcher"
                onClick={this.handleLauncherClicked}
              >
                <cr-icon-bucket size="large"/>
                <div class="discovery-count">{this.professionals.length + this.leads.length}</div>
              </div>
            </div>
            <bx-accordion>
              <bx-accordion-item title-text={`Professionals (${this.professionals.length})`}>
                <cr-professionals-bucket
                  professionalDiscoveries={this.professionals}
                />
              </bx-accordion-item>
              <bx-accordion-item title-text={`Leads (${this.leads.length})`}>
                <cr-leads-bucket
                  leadDiscoveries={this.leads}
                />
              </bx-accordion-item>
            </bx-accordion>
            <div class="buckets-bar-actions">
              <bx-btn
                size="sm"
                kind="ghost"
                onClick={this.flushBuckets}
              >Clear</bx-btn>
            </div>
          </bx-side-nav-items>
        </bx-side-nav>
      </Host>
    );
  }

  constructor() {
    this.addDiscovery = this.addDiscovery.bind(this)
  }

  private professionalService: ProfessionalService = new ProfessionalService()
  private professionalLeadService: ProfessionalLeadService = new ProfessionalLeadService()

  private handleLauncherClicked = (e: MouseEvent) => {
    e.preventDefault()
    this.openBuckets = !this.openBuckets
  }

  private onlyProfessionals = (discovery: SearchResultItem) => discovery.scope === 'professional'
  private onlyLeads = (discovery: SearchResultItem) => discovery.scope === 'lead'

  private save = () => {
    localStorage.setItem('discoveries', JSON.stringify(this.discoveries))
  }

  private load = () => {
    const discoveries = localStorage.getItem('discoveries')
    if (discoveries !== null) {
      this.discoveries = JSON.parse(discoveries)
    } else {
      this.discoveries = []
    }
  }

  private getDiscoveryDetails = async (discovery: SearchResultItem) => {
    let detail = null
    switch (discovery.scope) {
      case 'professional':
        detail = await this.professionalService.getDetails(discovery.id)
        break
      case 'lead':
        detail = await this.professionalLeadService.getDetails(discovery.id)
        break
    }
    return detail
  }

  private flushBuckets = () => {
    this.discoveries = []
    this.save()
  }
}
